<template>
  <div class="absolute w-full h-full left-0 top-0 text-center overflow-visible">
    <div class="progress">{{ progress }}%</div>
    <div class="scan-light" :style="{ bottom: `${progress * 0.9}%` }"></div>
    <!--    <img class="circle outer" src="../../assets/Doll/scan-floor-circle.svg" />-->
    <!--    <img class="circle inner" src="../../assets/Doll/scan-floor-circle.svg" />-->
  </div>
</template>

<script>
export default {
  name: 'ScanProgress',
  props: {
    progress: Number,
  },
};
</script>

<style lang="scss" scoped>
.progress {
  @apply relative text-white font-bold mx-auto pl-2;
  font-size: 32px;
  top: 18%;
}
.circle {
  @apply absolute bottom-0 mx-auto;
  left: -50%;
  right: -50%;
  &.outer {
    max-width: 180%;
    opacity: 0.4;
    bottom: -10%;
  }
  &.inner {
    width: 100%;
    bottom: -5%;
  }
}
.scan-light {
  @apply absolute;
  width: 100%;
  height: 46px;
  opacity: 0.5;
  border-radius: 20px;
  filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgb(206, 221, 229);
  will-change: bottom;
}
</style>
